import React from 'react'
import ReactDom from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "../App";
import './css/splash.css'

const Splash = () => {
  setTimeout(() => {
    ReactDom.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>,
      document.getElementById("root")
    );
  }, 2000);
  return (
    <div className="splash-screen">
      <p
        id="header"
        className="fw-bolder text-info"
        style={{ fontSize: "60px" }}
      >
        MWEREZI INTERNATIONAL
      </p>
      {/* <p id="header">Global leader in technology business solution</p> */}
      <p id="header">presents...</p>
      <p
        id="body"
        className="fw-bolder text-success"
        style={{ fontSize: "60px" }}
      >
        MPOS
      </p>
      <p id="body">
        state of the art pos for your retail business.
      </p>
    </div>
  );
}

export default Splash